



































































































































































































import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import DebounceMixin from '@/mixins/DebounceMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import DialogWork from '@/components/DialogWork.vue';
import DialogAvatar from '@/components/Avatar.vue';
import DialogUploadCertificate from '@/components/DialogUploadCertificate.vue';
import {usersModule} from '@/store/modules/users';

interface MessageCheckUser {
  point: number;
  pesan: string[];
}
interface Users {
  foto: string;
}
@Component({
  components: {DialogWork, DialogAvatar, DialogUploadCertificate},
})
export default class Dashboard extends mixins(
  LoadingMixin,
  SnackbarMixin,
  DebounceMixin,
) {
  dialogWork = false;
  dialogCetificate = false;
  crouserlData = false;
  isLoadingExperience = false;
  idExperience = '';
  messageCheckUser: MessageCheckUser = {point: 0, pesan: []}; // Initialize with default values
  dialogAvatar = true;
  users: Users = {
    foto: '',
  };
  items: {src: string}[] = []; // Declare type for items

  listExperience = [];
  listCertification = [];
  get profile() {
    return JSON.parse(localStorage.getItem('USER') || '{}');
  }
  async mounted() {
    this.fetchDetail();
    await this.fecthCertification();
    await this.fecthJobExperience();
    await this.checkProgress();
    await this.getBanner();
  }

  async fetchDetail() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('biodata/getBiodata');
      this.finishLoading('detail');

      if (data !== null) {
        this.users = data;
      }
    } catch (e) {
      this.catchError(e);
    }
  }

  showEditExperience(val: any) {
    this.idExperience = val.id;
    this.dialogWork = true;
  }
  async deleteCertificate(values: any) {
    const confirmed = await this.$dialog.delete();

    if (confirmed) {
      try {
        const formData = {
          path: values.path,
        };
        const {message} = await this.$store.dispatch(
          'users/deleteCertificate',
          {id: values.id, payload: formData},
        );
        this.handleSuccess(message);
        this.fecthCertification();
      } catch (e) {
        this.catchError(e);
      }
    }
  }
  async checkProgress() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('jobs/checkProgress');
      this.finishLoading('detail');
      this.messageCheckUser = data;
    } catch (e) {
      this.catchError(e);
    }
  }
  async getBanner() {
    try {
      const {data} = await this.$store.dispatch('banner/getBanner');
      const linkWebsite = process.env.VUE_APP_LINK_WEBSITE;

      // Fill the items array using the data directly
      this.items = data.map((item: any) => {
        const fullUrl = linkWebsite + item.image; // Adjust the property name based on your data structure
        return {
          src: fullUrl,
        };
      });
    } catch (e) {
      this.catchError(e);
    }
  }

  async saveFileCertificate(values: any) {
    try {
      this.startLoading('saving');
      const form = {
        file_url: values.files.url,
        path: values.files.path,
        title: values.title,
      };
      await this.$store.dispatch('users/saveCertificate', form);
      this.finishLoading('saving');
    } catch (e) {
      this.catchError(e);
    }
  }
  async fecthJobExperience() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('jobExperience/all');
      this.finishLoading('detail');

      this.listExperience = data;
      this.isLoadingExperience = false;
    } catch (e) {
      this.isLoadingExperience = false;
      this.catchError(e);
    }
  }
  async fecthCertification() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('users/getCertificate');
      this.finishLoading('detail');

      this.listCertification = data;
    } catch (e) {
      this.catchError(e);
    }
  }
}
